import type { PbxSummary } from './usePbxSwitchExecutor'

export const PENDING_PBX_SWITCH_STATE_KEY = 'pendingPbxSwitch'

export interface PendingPbxSwitchLocationState {
  [PENDING_PBX_SWITCH_STATE_KEY]?: PbxSummary
}

export function getPendingPbxSwitch(state: unknown): PbxSummary | undefined {
  if (!state || typeof state !== 'object') return undefined

  const pendingPbx = (state as PendingPbxSwitchLocationState)[
    PENDING_PBX_SWITCH_STATE_KEY
  ]
  if (
    !pendingPbx ||
    typeof pendingPbx.id !== 'number' ||
    typeof pendingPbx.name !== 'string'
  ) {
    return undefined
  }

  return pendingPbx
}

export function omitPendingPbxSwitch(
  state: unknown,
): Record<string, unknown> | null {
  if (!state || typeof state !== 'object') return null

  const { [PENDING_PBX_SWITCH_STATE_KEY]: _pendingPbxSwitch, ...rest } =
    state as PendingPbxSwitchLocationState

  return Object.keys(rest).length > 0 ? rest : null
}
